module.exports = __webpack_public_path__ + "static/media/termopary8ru.8798ebda.pdf";